import axios from "axios";
export default {
	data() {
		return {
			numeratoriPathResources: "/numeratori/elenco",
			numeratorePathResources: "/numeratori",
		};
	},
	methods: {
		numeratoriLoadData(numeratoriLoadDataSuccess, codiceStruttura) {
			let me = this;
			let link = process.env.VUE_APP_PATH_API + me.numeratoriPathResources + "?codiceStruttura=" + codiceStruttura;
			axios.get(link)
				.then((response) => {
					numeratoriLoadDataSuccess(response);
				})
				.catch((error) => {
					this.$bvToast.toast("Errore nel salvarei dati: " + error.message, {
						title: "",
						variant: "danger",
						solid: true,
					});
				});
		},
		loadNumeratoreById(numeratoriLoadDataSuccess, id) {
			let me = this;
			let link = process.env.VUE_APP_PATH_API + me.numeratorePathResources + "/" + id;
			axios.get(link)
				.then((response) => {
					numeratoriLoadDataSuccess(response);
				})
				.catch((error) => {
					error;
					this.$bvToast.toast("Errore durante il recupero ", {
						title: "",
						variant: "danger",
						solid: true,
					});
				});
		},
	},
};
